import moment from "moment"
export const formatDate = (dateNo, format) => {
    if (dateNo) {
        const rawDate = new Date(parseInt(dateNo))
        return moment(rawDate).format(format ? format : "YYYY-MM-DD")

    }
    return ""
}
